import config from '../config';
import { Brands } from '../constants/AppConstants';

export function getBrandInfo() {
    const brand = config.get('brand');
    const isSouthEastern = brand === 'southeastern';
    const isGTR = Object.values(Brands).includes(brand);
    const isTranspennine = brand === 'transpennine';

    return { brand, isSouthEastern, isGTR, isTranspennine };
}
